import styled, { css } from 'styled-components';

interface CoachNameHeaderProps {
  isMe?: boolean;
}

interface ContainerScrollableProps {
  disableScrollable: boolean;
  isDaily?: boolean;
}

interface HeaderWeekDayWrapperProps {
  $y?: number;
  isSticky?: boolean;
}

export const CoachNameHeader = styled.div<CoachNameHeaderProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: ${({ theme, isMe }) =>
    isMe ? theme.palette.brand400 : theme.palette.grayscale300};
  ${({ theme }) => theme.typography('$body_03')};
`;

export const ChipButtonsWrapper = styled.div`
  padding-top: 12px;
`;

export const ContainerScrollable = styled.div<ContainerScrollableProps>`
  position: relative;
  width: 100%;

  ${({ isDaily }) =>
    isDaily &&
    css`
      padding-top: 34px;
    `}

  ${({ disableScrollable }) =>
    !disableScrollable &&
    css`
      overflow-x: auto;
    `}
`;

export const HeaderWeekDayWrapper = styled.div.attrs<HeaderWeekDayWrapperProps>(
  ({ $y }) => ({
    style: {
      top: `${$y}px`
    }
  })
)<HeaderWeekDayWrapperProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 20;
  background-color: var(--color-background);

  /* ${({ isSticky }) =>
    isSticky &&
    css`
      position: fixed;
      top: 0;
      left: 0;
    `} */
`;

export const TimelineWrapper = styled.div`
  position: relative;
  padding: 0 20px;
`;
